import { gql } from "@apollo/client";

// Per-user theming Designer — GraphQL against the C1 server API (main /graphql).
// Every field is JWT-scoped to the caller (no userId args); the console edits the
// caller's OWN draft and publishes it to their OWN app.

const RESOLVED_GLOBALS = `
  globals { token hex alpha isDefault defaultHex defaultAlpha }
  pages { pageId colors { token hex alpha } }
`;

export const MY_DESIGN_DRAFT = gql`
  query MyDesignDraft {
    myDesignDraft {
      revision
      dirty
      ${RESOLVED_GLOBALS}
    }
  }
`;

export const UPDATE_MY_DESIGN_DRAFT = gql`
  mutation UpdateMyDesignDraft($input: MyDesignDraftInput!) {
    updateMyDesignDraft(input: $input) {
      revision
      dirty
      ${RESOLVED_GLOBALS}
    }
  }
`;

export const PUBLISH_MY_DESIGN = gql`
  mutation PublishMyDesign {
    publishMyDesign {
      ok
      errors
      design {
        revision
        dirty
        ${RESOLVED_GLOBALS}
      }
    }
  }
`;
